import { render } from "./App.vue?vue&type=template&id=65e4fac2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./App.vue?vue&type=style&index=1&id=65e4fac2&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__